import { useState } from "react";
import { signUp, signIn, confirmSignUp } from "aws-amplify/auth";
import { useAuth } from "../auth/AuthContext";

// Sign up / sign in / verify, mirroring Diver's Horizon's AuthScreen.jsx flow. `promptMessage` gives a
// contextual reason for why the auth screen opened (Phase 1+ — every blocked action should build this
// the way Diver's Horizon's authPromptFor(reason) does); `onCancel` lets a guest back out.
export function AuthScreen({ promptMessage, onCancel, onSignedIn }) {
  const { refresh } = useAuth();
  const [mode, setMode] = useState("signIn"); // signIn | signUp | verify
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      if (mode === "signUp") {
        await signUp({ username: email, password, options: { userAttributes: { email } } });
        setMode("verify");
      } else if (mode === "verify") {
        await confirmSignUp({ username: email, confirmationCode: code });
        setMode("signIn");
      } else {
        await signIn({ username: email, password });
        await refresh();
        onSignedIn?.();
      }
    } catch (err) {
      setError(err.message || String(err));
    }
  };

  return (
    <div className="glass auth-screen">
      {onCancel && (
        <button className="auth-close-btn" onClick={onCancel} aria-label="Close">
          ×
        </button>
      )}
      {promptMessage && <p className="auth-context-message">{promptMessage}</p>}
      <form onSubmit={handleSubmit}>
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        {mode !== "verify" && (
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        )}
        {mode === "verify" && (
          <input
            type="text"
            placeholder="Verification code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        )}
        {error && <p className="badge-warn">{error}</p>}
        <button type="submit" className="btn-accent">
          {mode === "signUp" ? "Sign up" : mode === "verify" ? "Verify" : "Sign in"}
        </button>
      </form>
      {mode !== "verify" && (
        <button className="auth-subtitle" onClick={() => setMode(mode === "signIn" ? "signUp" : "signIn")}>
          {mode === "signIn" ? "Need an account? Sign up" : "Already have an account? Sign in"}
        </button>
      )}
    </div>
  );
}
